export const API_BASE_URL = import.meta.env.VITE_API_URL;

export const DEFAULT_PAGE_SIZE = 50;
export const LOGIN_API = `${API_BASE_URL}/auth/login`;
export const REFRESH_TOKEN_API = `${API_BASE_URL}/auth/refresh`;
export const LOGOUT_API = `${API_BASE_URL}/auth/logout`;
export const USER_DATA_API = `${API_BASE_URL}/users/me`;
export const APP_NAME = "JOOST System";
export const DEFAULT_IMAGE_BACKGROUND =
  "https://res.cloudinary.com/oceanmind/image/upload/v1750502667/ChatGPT_Image_17_39_01_21_thg_6_2025_1_techvk.png";
export const GOOGLE_AUTH_URL = API_BASE_URL + "/auth/google";

export const DEMO_PDF_URL =
  "https://res.cloudinary.com/oceanmind/raw/upload/v1762420377/CADINVO/dt0pqsf0yplyxh3ause5.pdf";
export const DEMO_DOCX_URL =
  "https://res.cloudinary.com/oceanmind/raw/upload/v1762420377/CADINVO/aeweeae5qnix8excj0wq.docx";
export const DEMO_XLSX_URL =
  "https://res.cloudinary.com/oceanmind/raw/upload/v1762420379/CADINVO/oicusf1xywzyeursp2fn.xlsx";
export const DEMO_IMAGE_URL =
  "https://res.cloudinary.com/oceanmind/image/upload/v1762420378/CADINVO/b8koyrgaerfkjrtsmkml.png";
export const DEMO_MSG_URL =
  "https://res.cloudinary.com/oceanmind/raw/upload/v1762507889/whatsapp_uploads/yblpuajefei72qbmd9b6.msg";
export const DEMO_ZIP_URL =
  "https://res.cloudinary.com/oceanmind/raw/upload/v1762508085/whatsapp_uploads/flqsqadi2z5v2vrudres.zip";

export const N8N_CONVERT_TASK_WEBHOOK = import.meta.env
  .VITE_N8N_CONVERT_TASK_WEBHOOK;

export const N8N_TRANSLATE_EMAIL_WEBHOOK =
  "https://n8n.srv860252.hstgr.cloud/webhook/translate-email";

export const CLOUDINARY_CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
export const CLOUDINARY_UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;

export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

export const ROUTES = {
  LOGIN: "/login-admin",
  REGISTER: "/auth/register",
  FORGOT_PASSWORD: "/auth/forgot-password",
};

export const LOCALES = {
  EN: "en",
  VI: "vi",
  NL: "nl",
};
